import React, { ReactNode } from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { NumberField } from '../number-field';

interface ControlledNumberFieldProps<TFieldValues extends FieldValues>
  extends UseControllerProps<TFieldValues> {
  label?: string;
  labelInfo?: string;
  helperText?: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  incrementRate?: number;
  decrementRate?: number;
  min?: number;
  max?: number;
  allowEmpty?: boolean;
  actions?: ReactNode;
  'data-testid'?: string;
}

export function ControlledNumberField<TFieldValues extends FieldValues>({
  name,
  control,
  rules,
  label,
  labelInfo,
  placeholder,
  helperText,
  disabled,
  defaultValue,
  readOnly = false,
  incrementRate = 1,
  decrementRate = 1,
  min,
  max,
  allowEmpty = true,
  actions,
  'data-testid': dataTestId,
}: ControlledNumberFieldProps<TFieldValues>): React.ReactElement {
  return (
    <Controller<TFieldValues>
      control={control}
      rules={rules}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <NumberField
          name={name}
          data-testid={dataTestId}
          label={label}
          labelInfo={labelInfo}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          allowEmpty={allowEmpty}
          required={!!rules?.required}
          error={!!error?.message}
          helperText={helperText ?? error?.message}
          disabled={disabled}
          readOnly={readOnly}
          min={min}
          max={max}
          incrementRate={incrementRate}
          decrementRate={decrementRate}
          actions={actions}
        />
      )}
    />
  );
}
